module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Sea Freight Import Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-group', {
    staticStyle: {
      "margin": "0",
      "margin-bottom": "10px !important"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search (Assignment No. / Importer / BL No. / Container No.)"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.billingFilter),
      callback: function($$v) {
        _vm.billingFilter = $$v
      },
      expression: "billingFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-0 col-md-12"
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.seaImportData,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "ffImportId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ffImportSeries",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.viewExportSeaPage(row11.item)
            }
          }
        }, [_c('b', {
          style: (row11.item.seenExec == '0' ? 'color:red' : 'color:black')
        }, [_vm._v("\n                " + _vm._s(row11.item.ffImportSeries) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Raised From : " + _vm._s(row11.item.EmpLoc) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Assignment Date : " + _vm._s(_vm._f("moment")(row11.item.loginTime)) + "\n                "), _c('br')]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row11.item.is_locked == '1' &&
              (row11.item.finalBillingCompleted == 1 ||
                row11.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) ?
                _vm.LockUnLock(row11.item, 'locked') :
                ''
            }
          }
        }, [(
          row11.item.is_locked == '1' &&
          (row11.item.finalBillingCompleted == 1 ||
            row11.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br')], 1), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row11.item.allModuleId,
            "jb_series": row11.item.ffImportSeries
          }
        }), _vm._v(" "), (row11.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row11.item.ffImportSeries,
            "PMC_JOBID": row11.item.allModuleId.toString(),
            "PMC_JOBNO": row11.item.ffImportSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row11.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row11.item.ffImportSeries,
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffImportSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row11.item,
            "JobNo": row11.item.ffImportSeries,
            "JobID": row11.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row11.item.prbr_id) ? _c('BRFCard', {
          attrs: {
            "BRFDetails": null,
            "prbr_id": Number(row11.item.prbr_id)
          }
        }) : _vm._e(), _vm._v(" "), (row11.item.deleteRequestBy != '' && row11.item.deleteRequestBy != '0' && row11.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested\n              By : " + _vm._s(row11.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.deleteArrovedBy != '' && row11.item.deleteArrovedBy != '0' && row11.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved\n              By : " + _vm._s(row11.item.deleteArrovedBy)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "ContainerNo",
      fn: function(row5) {
        return [(row5.item.ContainerNo != null) ? _c('div', [(row5.item.ContainerNo != null) ? _c('div', _vm._l((row5.item.ContainerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])], 1)])
        })) : _vm._e()]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "containerTypeName",
      fn: function(row50) {
        return [(row50.item.containerTypeName != null) ? _c('div', [(row50.item.containerTypeName != null) ? _c('div', _vm._l((row50.item.containerTypeName.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2))])], 1)])
        })) : _vm._e()]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "placeOfReceipt",
      fn: function(row12) {
        return [_c('span', [_vm._v("\n              POR : " + _vm._s(row12.item.placeOfReceipt) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              Load Port : " + _vm._s(row12.item.loadPort) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              POD : " + _vm._s(row12.item.portOfDischarge) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              FPOD : " + _vm._s(row12.item.finalPlaceDelivery) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              S-Line : " + _vm._s(row12.item.shippingLine) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              BOE NO : " + _vm._s(row12.item.BOE_NO) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              BOE Date : " + _vm._s(row12.item.BOE_Date) + "\n              "), _c('br')])]
      }
    }, {
      key: "invoiceStatus",
      fn: function(row33) {
        return [_c('b', {
          style: (row33.item.invoiceStatus == '0' ? {
            color: 'green'
          } : {
            color: 'red'
          })
        }, [_vm._v(_vm._s(!row33.item.invoiceStatus ?
          "--" :
          row33.item.invoiceStatus == "1" ?
          "In-Progress" :
          row33.item.invoiceStatus == "0" ?
          "Sent To Accounts" :
          "--"))]), _vm._v(" "), (row33.item.sentForApproval && row33.item.sentForApproval == '1') ? _c('b', [_c('br'), _vm._v("\n              Sent for Approval\n            ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '1'
        ) ? _c('b', [_c('br'), _vm._v("\n              Was Sent for Approval and got Approved\n            ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '2'
        ) ? _c('b', [_c('br'), _vm._v("\n              Was Sent for Approval and got Rejected\n            ")]) : _vm._e()]
      }
    }, {
      key: "portOfDischarge",
      fn: function(row55) {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row55.item)
            }
          }
        }, [_vm._v("Summary &\n              Documents")]), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row55.item.allModuleId,
            "fk_client_id": row55.item.clientId,
            "fk_pod_id": row55.item.PODLocationId
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21811788","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/seaImport/viewSeaImportDetails.vue
// module id = 2457
// module chunks = 0